import React from "react";
import { Outlet } from "react-router-dom";
import "./BlogLayout.css";

const BlogLayout = () => {
  return (
    <div className="BlogLayout">
      <Outlet />
    </div>
  );
};

export default BlogLayout;
